import * as React from 'react';

import {FocusTrapZone} from '@fluentui/react/lib/FocusTrapZone';
import classnames from 'classnames';

import styles from './alert-box.module.css';

type Props = {
    onClose: (e?: React.SyntheticEvent<any>) => any;
    children?: any;
    trapFocus: {
        // Whether to disable the FocusTrapZone's focus trapping behavior.
        disabled?: boolean;
        // If false (the default), the trap zone will restore focus to the element
        // which activated it once the trap zone is unmounted or disabled.
        // Set to true to disable this behavior.
        ignoreExternalFocusing?: boolean;
        // Sets the element to focus on when exiting the FocusTrapZone.
        elementToFocusOnDismiss?: React.ReactNode;
    };
    maxWidth?: number;
};

AlertBox.defaultProps = {
    trapFocus: {
        disabled: false,
    },
};

export function AlertBox(props: Props) {
    const appMount = document.getElementById('app-react-mount');
    const isAiAgentSidebarOpen = appMount && appMount.getAttribute('data-ai-agent-open') === 'true';

    const containerClassNames = classnames(styles.container, {
        [styles['container--ai-agent-sidebar-open']]: isAiAgentSidebarOpen,
    });

    return (
        <FocusTrapZone
            className='full-height full-width'
            isClickableOutsideFocusTrap={true}
            disabled={props.trapFocus.disabled}
            ignoreExternalFocusing={props.trapFocus.ignoreExternalFocusing}
            // @ts-expect-error
            elementToFocusOnDismiss={props.trapFocus.elementToFocusOnDismiss}
        >
            <div onClick={(e) => e.stopPropagation()} className={containerClassNames}>
                <div onClick={props.onClose} className={styles.backdrop} />
                <div
                    style={{maxWidth: props.maxWidth || 448}}
                    className={styles['input-container']}
                >
                    {props.children}
                </div>
            </div>
        </FocusTrapZone>
    );
}
